import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import LoginContainer from 'components/pages/LoginContainer';
import Tabs, { TabContent } from 'components/Tabs/VoteSwiperHashTabs';
import Vote1 from 'components/pages/Home/TabContent/Vote1';
import Vote2 from 'components/pages/Home/TabContent/Vote2';
import Vote3 from 'components/pages/Home/TabContent/Vote3';
import Vote4 from 'components/pages/Home/TabContent/Vote4';
import Vote5 from 'components/pages/Home/TabContent/Vote5';
import { getAwardsData, getThemeData } from 'services/authService';
import Skeleton from '@mui/material/Skeleton';
import useGa from 'hooks/useGa';

export default function Home() {

    return (
        <div className="home-page">
            <Banner />
            <SwiperContainer />
            <VoteContainer />
        </div>
    );
}

const VoteTabs = () => {
    let mounted = true;
    const [ tab, setTab ] = useState();
    const [ themeData, setThemeData ] = useState({
        open_round: 0,
        theme_list: [
            {
                type: "",
                win: "",
            },
            {
                type: "",
                win: "",
            },
            {
                type: "",
                win: "",
            },
            {
                type: "",
                win: "",
            },
            {
                type: "",
                win: "",
            },
        ],
    });

    useEffect(() => {
        const fetchThemeData = async() => {
            let result = await getThemeData();
            if(mounted){
                setThemeData(result);
            }
        }
        fetchThemeData();
        return () => mounted = false;
    }, [])

    const handleTab = () => {
        switch (themeData.open_round){
            case 0: return "#vote1";
            case 1: return "#vote1";
            case 2: return "#vote2";
            case 3: return "#vote3";
            case 4: return "#vote4";
            case 5: return "#vote5";
            default: return "#vote1";
        }
    }

    return (
        <div className="vote-tab-container">
            <Tabs to="/" defaultValue={handleTab} value={tab} onChange={setTab} themeData={themeData} ></Tabs>
            <div className="vote-tab-content">
                <div className="dot dot1"></div>
                <div className="dot dot2"></div>
                <div className="dot dot3"></div>
                <div className="dot dot4"></div>
                <TabContent value={tab ? tab : "#vote1"}>
                    <Vote1 value="#vote1" themeData={themeData.theme_list[0]} />
                    <Vote2 value="#vote2" themeData={themeData.theme_list[1]} />
                    <Vote3 value="#vote3" themeData={themeData.theme_list[2]} />
                    <Vote4 value="#vote4" themeData={themeData.theme_list[3]} />
                    <Vote5 value="#vote5" themeData={themeData.theme_list[4]} />
                </TabContent>
            </div>
        </div>
    )
}

const Banner = () => {
    const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);

    return (
        <div className={`banner${isAuthenticated ? ' sign-in' : ''}`}>
            { !isAuthenticated && <LoginContainer /> }
        </div>
    )
}

const VoteContainer = () => {
    return (
        <div className="vote-container">
            <VoteInformation />
            <VoteTabs />
        </div>
    )
}

const VoteInformation = () => {
    const gaTracking = useGa();

    return (
        <div className="information-container">
            <div className="information-desc">
                <div className="desc pc">
                    <div>活動期間凡購買指定活動商品，憑瓶身貼紙序號兌點，</div>
                    <div>1點即1票，把點數投給你支持的品牌飲料、也可同時投票給兩方。</div>
                    <div>每周將釋出不同PK題目，採五戰三勝制，如果你支持的那一方取得最終勝利，</div>
                    <div>就有機會抽中胡同燒肉的豪華和牛宴！投越多票中獎機會越大！</div>
                </div>
                <div className="desc mb">
                    <div>活動期間凡購買指定活動商品，</div>
                    <div>憑瓶身貼紙序號兌點，1點即1票，</div>
                    <div>把點數投給你支持的品牌飲料、也可同時投票給兩方。</div>
                    <div>每周將釋出不同PK題目，採五戰三勝制，</div>
                    <div>如果你支持的那一方取得最終勝利，</div>
                    <div>就有機會抽中胡同燒肉的豪華和牛宴！</div>
                    <div>投越多票中獎機會越大！</div>
                </div>
                <Link to="/activity" className="common-btn yellow" target="_blank" onClick={() => gaTracking("index-to-activity")}>詳見活動辦法</Link>
            </div>
        </div>
    )
}

const SwiperContainer = () => {
    let mounted = true;
    const [ awardsData, setAwardsData ] = useState([]);
    const gaTracking = useGa();

    useEffect(() => {
        const fetchawardsData = async() => {
            let result = await getAwardsData();
            if(mounted){
                setAwardsData(result.awards_list);
            }
        }
        fetchawardsData();
        return () => mounted = false;
    }, [])

    const PageLoading = () => {
        return (<>
            <Swiper
                className="giveaway-swiper"
                allowTouchMove={false}
                noSwiping={true}
                slidesPerView="auto"
            >
                {
                    Array(parseInt(8)).fill().map((item, index) =>
                        <SwiperSlide key={index}>
                            <div className="swiper-item">
                                <div className="w-100 bg-white" style={{position: "relative", padding: "2px"}}>
                                    <div className="img pdt-3" style={{backgroundColor: "#eee"}}>
                                        <Skeleton variant="rectangular" height="100%" width="100%" style={{borderRadius: "9px 9px 0 0"}} />
                                    </div>
                                    <div className="point" style={{backgroundColor: "transparent", padding: "0"}}>
                                        <Skeleton variant="rectangular" height="25px" width="65px" style={{borderRadius: "4px"}} />
                                    </div>
                                </div>
                                <div className="text">
                                    <Skeleton variant="rectangular" height="24px" width="100px" style={{borderRadius: "4px", position: "relative", top: "6.5px"}} />
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                }
            </Swiper>
        </>)
    }

    return (
        awardsData.length > 0 ? (
            <Swiper
                className="giveaway-swiper"
                modules={[Navigation, Autoplay]}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                slidesPerView="auto"
                navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }}
            >
                <SwiperSlide>
                    <div className="swiper-item">
                        <div className="w-100 bg-white" style={{position: "relative", padding: "15px 2px 2px 2px"}}>
                            <div className="img img0"></div>
                            <div className="point">1點投票<span className="spec">抽</span></div>
                        </div>
                        <div className="text">胡同燒肉豪華和牛宴</div>
                    </div>
                </SwiperSlide>
                {
                    awardsData.map((item, index) =>
                        <SwiperSlide key={index}>
                            <div className={`swiper-item${item.awards_last_nu !== "∞" && parseInt(item.awards_last_nu) === 0 ? ' sold-out' : ''}`}>
                                <div className="w-100 bg-white" style={{position: "relative", padding: "15px 2px 2px 2px"}}>
                                    <div className={`img img${item.awards_id}`}></div>
                                    <div className="point">{item.awards_points}點</div>
                                    {
                                        item.awards_last_nu !== "∞" && parseInt(item.awards_last_nu) <= 10 && parseInt(item.awards_last_nu) > 0 &&
                                        <label className="last">僅剩{item.awards_last_nu}組</label>
                                    }
                                </div>
                                <div className="text">{item.awards_item}</div>
                            </div>
                        </SwiperSlide>
                    )
                }
                <div className="swiper-button-prev" onClick={() => gaTracking("giveaway-swiper-prev")}></div>
                <div className="swiper-button-next" onClick={() => gaTracking("giveaway-swiper-next")}></div>
            </Swiper>
        ) : (
            <PageLoading />
        )
    )
}